export const ErrorCodes = {
    redirectToHome: 1,
    redirectToOrders: 2,
    redirectToProductionManagement: 3
}
